import React from "react";
import { Grid, Paper, Typography, Button } from "@mui/material";
import AttendeeMatches from "./AttendeeMatches";
import { EventContext } from "../../../contexts/EventContext";

import request from "../../../utilities/requests";

const MatchResults = () => {
  const { pairingEvent } = React.useContext(EventContext);
  const [attendeeMatches, setAttendeeMatches] = React.useState([]);
  const [matchRate, setMatchRate] = React.useState('');
  const [view, setView] = React.useState("byAttendee");

  React.useEffect(() => {
    if (pairingEvent && attendeeMatches.length === 0) {
      getAttendeeMatches();
    }
  }, [attendeeMatches, pairingEvent]);

  const getAttendeeMatches = async () => {
    const result = await request(
      `pairingevent/attendeematches?pairingEventId=${pairingEvent._id}`
    );
    if (!result.success) {
      return;
    }
    setAttendeeMatches(result.attendeeMatches);
    setMatchRate(result.matchRate);
  };

  // const handleEmail = async () => {
  //   const body = {
  //     pairingEventId: pairingEvent._id,
  //   };

  //   const result = await request("pairingevent/sendmatchemails", "post", body);
  //   if (result.success) {
  //     alert("Match emails send successfully!");
  //   }
  // };

  return (
    <>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Grid container directioin="row" spacing={1}>
            <Grid item>
              <Typography style={{ padding: 10,fontWeight: 'bold' }}>Match Results</Typography>
            </Grid>
            <Grid item>
              <Typography style={{ padding: 10 }}>Match Rate: {matchRate}%</Typography>
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item xs={2}>
          <Button onClick={handleEmail}>Email</Button>
        </Grid> */}
      </Grid>
      {view === "byAttendee" ? (
        <AttendeeMatches data={attendeeMatches} />
      ) : (
        <Paper height={3} style={{ width: "100%" }}></Paper>
      )}
    </>
  );
};

export default MatchResults;
